export default function ThreeColumnSection() {
  const features = [
    {
      icon: '📚',
      title: 'やさしく学べる',
      description: '専門用語は使わず、初心者の方でもわかりやすい言葉で説明します。一歩ずつ、ゆっくり進めていきましょう。',
    },
    {
      icon: '📊',
      title: '図解でわかる',
      description: '複雑な仕組みも、図やイラストで視覚的に理解できます。見て、読んで、納得できる情報をお届けします。',
    },
    {
      icon: '🤝',
      title: '仲間とつながる',
      description: '同じ冒険をする仲間たちと情報交換。わからないことも、みんなで解決していける安心のコミュニティです。',
    },
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center group hover:scale-105 transition-transform duration-300"
            >
              <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center text-6xl">
                {feature.icon}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}